import SpriteSymbol from "../../../node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../../node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "undo",
  "use": "undo-usage",
  "viewBox": "0 0 512 512",
  "content": "<symbol xmlns=\"http://www.w3.org/2000/svg\" xmlns:xlink=\"http://www.w3.org/1999/xlink\" viewBox=\"0 0 512 512\" id=\"undo\">\r\n<g id=\"undo_XMLID_2_\">\r\n\t<path id=\"undo_XMLID_4_\" d=\"M130.8,19.7L0,151.2l130.8,131.5l34.7-34.7l-72.5-74.8h236.3c76.4,0,137.1,61.4,137.1,137.1\r\n\t\tc0,76.4-61.4,137.1-137.1,137.1H54.4v44.9h274.9c100.8,0,182.7-81.9,182.7-182.7s-81.9-182.7-182.7-182.7H92.9l72.5-73.3\r\n\t\tL130.8,19.7z\" />\r\n</g>\r\n</symbol>"
});
var result = sprite.add(symbol);
export default symbol